export const ConvertDateObjectToTimeFormat = (time) => {
  const Time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
  })?.format(time);
  return Time;
};
